/**
 * @generated SignedSource<<73c50100ed235e01de5b51da02dc68ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ClientEngagementNewPageQuery$variables = Record<PropertyKey, never>;
export type ClientEngagementNewPageQuery$data = {
  readonly facebookLoginEnabled: boolean;
  readonly viewer: {
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type ClientEngagementNewPageQuery = {
  response: ClientEngagementNewPageQuery$data;
  variables: ClientEngagementNewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "facebookLoginEnabled",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientEngagementNewPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ClientEngagementNewPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c33b6eb2f9129e63f363b14b3b2d4062",
    "id": null,
    "metadata": {},
    "name": "ClientEngagementNewPageQuery",
    "operationKind": "query",
    "text": "query ClientEngagementNewPageQuery {\n  viewer {\n    id\n    name\n  }\n  facebookLoginEnabled\n}\n"
  }
};
})();

(node as any).hash = "ac2cf2c7d9ae91998c0c323d488a1ee7";

export default node;
